module.exports = {
	setCategories: (state, categories) => {
		if (categories) {
			Vue.set(state, "categories", categories);
		}
	},

	setLoadedCategory: (state, category) => {
		if (!state.loadedCategories) {
			Vue.set(state, "loadedCategories", {});
		}

		const loadedCategory = state.loadedCategories[category.slug];

		if (loadedCategory) {
			_.forEach(category, (value, key) => {
				if (key !== "id") {
					Vue.set(loadedCategory, key, value);
				}
			});
		} else {
			Vue.set(state.loadedCategories, category.slug, category);
		}
	},

	setSelectedCategory: (state, slug) => {
		if (state.selectedCategory === slug) {
			return;
		}

		Vue.set(state, "selectedCategory", slug);
	},

	setPermissionGroups: (state, payload) => {
		Vue.set(state, "permissionGroups", payload);
	},

	setDocuments: (state, payload) => {
		Vue.set(state, "documents", payload);
	},

	deleteDocument: (state, payload) => {
		const index = _.findIndex(state.documents, { id: payload.document_id });

		state.documents.splice(index, 1);
	},

	removeDocumentCategory: (state, payload) => {
		const index = _.findIndex(state.documents, { id: payload.document_id });
		const category_index = _.findIndex(state.documents[index].categories, {
			id: payload.category_id
		});

		state.documents[index].categories.splice(category_index, 1);
	},

	resetDocument: state => {
		state.documents = [];
	},

	updateDocumentFields(state, { document, selectedDocument }) {
		const foundDocument =
			selectedDocument ||
			_.find(state.documents, item => {
				return item.id === +document.id;
			});

		_.forEach(document, (value, key) => {
			if (key !== "id") {
				Vue.set(foundDocument, key, value);
			}
		});
	}
};
